{
  "dss": {
    "button": {
      "back": "Артқа",
      "cancel": "Бас тарту",
      "close": "Жабу",
      "confirmDelete": "Иә, өшіру",
      "continue": "Жалғастыру",
      "logout": "Шығу",
      "passwordReset": "Құпия сөзді қалпына келтіру",
      "save": "Сақтау",
      "verify": "Растау"
    },
    "error": {
      "403": "Бұл бетке қол жеткізу құқығыңыз жоқ.",
      "404": "Бұл бет жоқ.",
      "generic": "Қате орын алды. Кейінірек қайта көріңіз.",
      "invalidConfirmationLink": "Растау сілтемесінің мерзімі өткен немесе жарамсыз.",
      "throttling": "Тым көп әрекет жасалды. Бұл операция біраз уақытқа бұғатталды.",
      "title": "Қате",
      "title403": "Қол жеткізу тыйым салынған",
      "title404": "Табылмады"
    },
    "footer": {
      "imprint": "Импринт",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Құпиялылық саясаты",
      "terms": "Шарттар"
    },
    "label": {
      "CRMAccountNumber": "CRM есептік нөмірі",
      "contact": "Байланыс",
      "email": "Эл. пошта",
      "faq": "ЖҚС",
      "female": "Ханым",
      "firstname": "Аты",
      "help": "Көмек",
      "language": "Тіл",
      "lastname": "Тегі",
      "male": "Мырза",
      "needHelp": "Көмек керек пе?",
      "newPassword": "Жаңа құпия сөз",
      "newPassword2": "Жаңа құпия сөзді растау",
      "oldPassword": "Ағымдағы құпия сөз",
      "organization": "Ұйым",
      "password": "Құпия сөз",
      "required": "міндетті",
      "salutation": "Құрметтеу",
      "select": "Таңдаңыз"
    },
    "lang": {
      "de": "Неміс"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Тіркелуді растау",
        "wait": "Есептік жазбаны растау аяқталғанша күтіңіз."
      },
      "otp": {
        "btnResend": "Растау кодын қайта жіберу",
        "msg": {
          "invalidOTP": "Енгізілген бір реттік құпия сөз жарамсыз.",
          "resendFail": "Кодты қайта жіберу сәтсіз болды. Кейінірек қайта көріңіз."
        },
        "spamDetail": "Кіріс жәшігіңізді және Спам бумасын STIHL Support (noreply{'@'}stihl-sso.com) хатына тексеріңіз",
        "spamTitle": "Хат келмеді ме?",
        "subtitle": "Жалғастыру үшін эл. пошта мекенжайыңызды растауыңыз керек.",
        "title": "Пайдаланушы тіркелгіңізді растаңыз",
        "txtVerifyMail": "Эл. пошта мекенжайыңыз {email} адресіне жіберілген жаңа растау кодын енгізіңіз"
      },
      "personal": {
        "msg": {
          "noChange": "Жаңартатын ештеңе жоқ.",
          "updateError": "Жеке деректерді жаңарту сәтсіз аяқталды.",
          "updated": "Жеке деректер жаңартылды.",
          "userLoadErr": "Пайдаланушы деректерін жүктеу кезінде қате орын алды. Кейінірек қайта көріңіз."
        },
        "secOrganization": "Ұйым",
        "secPersonal": "Жеке",
        "secSettings": "Таңдаулы баптаулар",
        "title": "Жеке ақпарат"
      },
      "postPwSet": {
        "info": "Енді жаңа құпия сөзіңізді пайдалана аласыз.",
        "link_name": "Self-Service қызметіне өту",
        "link_url": "/user/ui/",
        "title": "Құпия сөзіңіз өзгертілді"
      },
      "resetPW": {
        "title": "Құпия сөзіңізді қалпына келтіру"
      },
      "security": {
        "2fa": {
          "availableMethods": "Қолжетімді 2FA әдістері:",
          "info": "Екі факторлы аутентификация (2FA) – тіркелгіңізді қосымша қорғайтын функция. Ол тек пайдаланушы аты мен құпия сөздің орнына кіру үшін екі әдісті қолдануды талап етеді.",
          "method": {
            "email": "Эл. пошта",
            "emailDesc": "Аутентификация сұранымдарын аяқтау үшін эл. пошта арқылы бір реттік кодтар алыңыз.",
            "oath": {
              "add": {
                "button": "Authenticator қолданбасын тіркеу"
              }
            }
          }
        },
        "authenticator": "Аутентификатор қолданбасы",
        "infoFederatedAccount": "Бұл есептік жазбаны ұйымыңыздың identity provider басқарады, сондықтан құпия сөзді осы жерде өзгерту мүмкін емес. Құпия сөзді өзгерту үшін ұйымыңыздың кіру бетінен жүйеге кіріңіз немесе IT әкімшісіне хабарласыңыз.",
        "lastUse": "Соңғы қолданылған уақыты: {0}.",
        "msg": {
          "invalidPassword": "Ағымдағы құпия сөз жарамсыз.",
          "passwordAlreadyUsed": "Соңғы 5 құпия сөзді қайта пайдалануға болмайды.",
          "pwUpdateError": "Құпия сөзді өзгерту кезінде қате орын алды.",
          "pwUpdated": "Құпия сөз өзгертілді."
        },
        "noDevice": "Бапталмаған",
        "oathAdd": {
          "appInfo": "STIHL жүйесіне кіруді жеңілдету үшін {0}, {1}, {2} және т.б. сияқты аутентификатор қолданбаларын пайдаланып, кіру процесінде екінші фактор ретінде қолданылатын бір реттік құпия сөздерді генерациялай аласыз.<br/>Егер мобильді құрылғыңызды жоғалтсаңыз немесе ұмытсаңыз, кез келген уақытта эл. пошта арқылы жіберілген 2FA кодын қолдана аласыз.<br/><br/>Төмендегі нұсқауларды орындап, аутентификация құрылғыңызды баптаңыз.",
          "badCode": "Жарамсыз код, қайта көріңіз.",
          "error": "Аутентификация құрылғысын тіркеу кезінде қате орын алды.",
          "headScan": "1. Authenticator қолданбасымен QR кодын сканерлеңіз",
          "headVerify": "2. Кодты растаңыз",
          "infoKey": "баптау кілті",
          "infoKeyTitle": "Екі факторлы құпияңыз",
          "infoScanBottom": "Сканерлей алмайсыз ба? Authenticator қолданбасын қолмен баптау үшін {0} қолданыңыз.",
          "infoVerify": "Authenticator қолданбасы жасаған кодты енгізіңіз.",
          "success": "Аутентификация құрылғыңыз тіркелді. Енді оны кіру үшін пайдалана аласыз.",
          "title": "Екі факторлы аутентификация құрылғысын тіркеңіз"
        },
        "oathDelete": {
          "error": "Аутентификация құрылғысын жою кезінде қате орын алды.",
          "success": "Аутентификация құрылғысы жойылды."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey – сіз басқаратын аутентификатор сақтайтын криптографиялық кілттер жұбы (жария кілт және жеке кілт). Аутентификатор пайдаланушының бар екенін және passkey-ді қолдануға уәкілетті екенін дәлелдей алады. Аутентификаторлар мүмкіндігі мен баптауына қарай PIN, код, биометрия немесе құрылғы құпия сөзі арқылы уәкілеттілікті дәлелдейді. Аутентификаторлар әртүрлі болады: iPhone немесе Android құрылғысы, Windows Hello, FIDO2 аппараттық қауіпсіздік кілті немесе құпия сөз менеджері.",
            "info2": "STIHL жүйесіне passkey көмегімен кіргенде, аутентификаторыңыз passkey-ді ешқашан жібермей-ақ, көпшілік кілт криптографиясын пайдаланып, жеке басыңызды STIHL алдында дәлелдейді. Passkey веб-сайт доменіне (мысалы, stihl-sso.com) байланған және қауіпсіз қосылымды қажет етеді, яғни браузер фишингке ұқсас сайтқа аутентификациялаудан бас тартады. Бұл қасиеттер passkey-ді фишингке өте төзімді етеді және SMS немесе TOTP 2FA-ға қарағанда шабуыл жасау әлдеқайда қиын.",
            "info3": "Бұлт арқылы синхрондалатын passkey қызметтері passkey-лерді құрылғылар арасында (Apple, Android құрылғылары немесе құпия сөз менеджерлері) синхрондауға мүмкіндік береді, сол арқылы оларды көбірек жерде пайдалануға және жоғалтып алу ықтималдығын азайтуға болады. Бір құрылғыда синхрондалған passkey орнатқаннан кейін, ол сол қызметті қолданатын бірнеше құрылғыда қолжетімді болады. Мысалы, MacBook құрылғыңызда Touch ID арқылы iCloud тіркелгіңізге passkey тіркеген болсаңыз, кейін осы passkey-ді бет, саусақ ізі, PIN немесе құрылғы құпия сөзімен сол iCloud тіркелгісіне байланыстырылған бірнеше құрылғыда алма-кезек қолдана аласыз.",
            "title": "Passkey туралы"
          },
          "add": {
            "button": "Жаңа Passkey қосу",
            "error": "Жаңа passkey қосу кезінде қате орын алды.",
            "success": "Жаңа passkey қосылды."
          },
          "delete": {
            "button": "Passkey-ді жою",
            "error": "Осы passkey-ді жою кезінде қате орын алды.",
            "success": "Passkey жойылды."
          },
          "edit": {
            "error": "Passkey атауын сақтау кезінде қате орын алды.",
            "name": "Passkey атауы",
            "success": "Passkey атауы жаңартылды.",
            "title": "Passkey-ге басқа passkey-лерден ажырату үшін атау беріңіз"
          },
          "info": "Passkey – бұл құпия сөздерге қарапайым әрі қауіпсіз балама, ол жеке басыңызды жанасу, бет әлпетін тану, құрылғы құпия сөзі немесе PIN арқылы растайды.",
          "none": "Ешбір Passkey бапталмаған.",
          "reallyDelete": "Passkey-ді шынымен жойғыңыз келе ме?",
          "registeredPasskeys": "Тіркелген Passkey-леріңіз:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Аутентификация құрылғысын шынымен жойғыңыз келе ме?",
        "secMFA": "Екі факторлы аутентификация",
        "secPwdChange": "Құпия сөзді өзгерту",
        "title": "Қауіпсіздік"
      },
      "setPW": {
        "acceptTC": "Біздің {terms} растап, {privacy} оқыңыз.",
        "killSSO": "Барлық белсенді сеанстарды жарамсыздандыру",
        "msg": {
          "tokenExpired": "Құпия сөзге арналған сілтеме немесе кодтың мерзімі аяқталды. Құпия сөзіңізді қалпына келтіру үшін сілтемені орындаңыз: {link}."
        },
        "privacy": "Деректердің құпиялылық саясаты",
        "terms": "Шарттар мен талаптар",
        "title": "Жаңа құпия сөз енгізіңіз"
      }
    },
    "validations": {
      "hasDigit": "Кемінде бір сан болуы керек",
      "hasLowercase": "Кемінде бір кіші әріп болуы керек",
      "hasSpecial": "Арнайы таңбалар болуы керек: {chars}",
      "hasUppercase": "Кемінде бір бас әріп болуы керек",
      "invalidCharacters": "Жарамсыз таңбалар бар",
      "maxLength": "Ең көбі {max} таңба рұқсат етіледі",
      "minLength": "Кемінде {min} таңба қажет",
      "notSameAsEmail": "Эл. пошта мекенжайына тым ұқсас",
      "onlyValidCharactersAllowed": "Тек әріптер, сандар және бос орындар рұқсат етіледі.",
      "required": "Міндетті өріс",
      "sameAsPassword": "Құпия сөздер сәйкес келмейді",
      "tcAccepted": "Пайдалану шарттарын растаңыз.",
      "validEmail": "Эл. пошта мекенжайы жарамсыз.",
      "validOTP": "Растау кодын енгізіңіз."
    }
  }
}
